import React from 'react';
import ApiActionButton from '@/components/Exceptions/ActionButtons/ApiActionButton';
import { ExceptionApiAction, ExceptionReference } from '@/redux/slices/slice_types';
import DrawerActionButton from '@/components/Exceptions/ActionButtons/DrawerActionButton';
import { getActionButtonLabel, getActionConfirmationDialogMessage } from '@/components/Exceptions/utils/utils';

interface Props {
  action: ExceptionApiAction;
  references: ExceptionReference[];
}

const DrawerApiActionButton: React.FC<Props> = ({ action, references }) => {
  const label = getActionButtonLabel(action, references);
  const dialogConfirmationMessage = getActionConfirmationDialogMessage(action.name);
  return (
    <ApiActionButton action={action} dialogConfirmationMessage={dialogConfirmationMessage}>
      {({ dialog, iconName, openDialog }) => (
        <>
          <DrawerActionButton isLink={false} label={label} iconName={iconName} onClick={openDialog} />
          {dialog}
        </>
      )}
    </ApiActionButton>
  );
};

export default DrawerApiActionButton;
